export const ERROR_CODE_MATCH_ALREADY_CONFIRMED_BY_ROLE = 1;
